export default {
  'drop-down': {
    position: 'relative',
  },
}
